import * as React from 'react';
import { connect } from 'react-redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { useHistory, useLocation } from 'react-router';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import styles from './index.module.scss';
import LOGO from '../../static/media/logo.png';
import appSetting from '../../utils/appSetting';
import { Button } from '@fluentui/react-northstar/dist/es/components/Button/Button';
import { openWindow } from '../../utils/dialog';
import hubService from '../../api/services/hub';



const Login = () => {
    const history = useHistory();
    const [showLogin, setShowLogin] = React.useState(localStorage.getItem("forceLogout") == "true");
    localStorage.setItem("forceLogout", "false");
    const time = new Date().getTime();
    var loginUrl = `${window.location.origin}/connect/authorize?state=${time}`;
    const login = () => {
        localStorage.setItem("state", time.toString());
        microsoftTeams.authentication.authenticate({
            height: 800,
            width: 600,
            successCallback: () => {
                localStorage.setItem("forceLogout", "false");
                if (appSetting.isAppConfigured()) {
                    history.push('/');
                } else {
                    history.push('/configure');
                }
            },
            failureCallback: () => {
                setShowLogin(true);
                loginUrl = `${window.location.origin}/connect/authorize?state=${time}`;
            },
            url: loginUrl
        });

    };
    
    
    if (!showLogin) {
        var token = localStorage.getItem("teams_token");
        if (token == null || token == "") {
            setShowLogin(true);
            loginUrl = `${window.location.origin}/connect/authorize?state=${time}`;
        }
        else {
            loginUrl = `${window.location.origin}/connect/hubtokenexchange?state=${time}&token=${token}`;
            login();
        }
    }
    

    const displaySSOLoading = () => {
        return (
            <>
                <p className={styles.desc2}>Please wait sign-in is in progress...</p>
            </>
        )
    };

    const displayLoginPage = () => {
        return (
         <>
            { showLogin && <div className={styles.container}>
                <img src={LOGO} alt="Bigtincan Hub" title="Hub" />
                <div className={styles.title}>Almost there!</div>
                <p className={styles.desc}>We need to ask for additional permissions. You should only need to do this once for Bigtincan. Your data is safe with us.</p>
                <PrimaryButton className={styles.continue} onClick={login}>Log in with Bigtincan Hub</PrimaryButton>
                <p className={styles.desc2} style={{ marginTop: '10px' }}>We do not support Signup for independent users.</p>
                <p className={styles.desc2}>To use this app you need to have licensed account with Bigtincan.</p>
                <p className={styles.desc2}><span className={styles.request} onClick={() => openWindow("https://go.bigtincan.com/contact-us")}>Click here</span> to contact us or <span className={styles.request} onClick={() => openWindow("https://www.bigtincan.com/request-demo/")}>Get a demo</span> </p>

            </div >
                }
            </>
)};
return (
    <>
        {showLogin && displayLoginPage()}
        {!showLogin && displaySSOLoading()}
    </>
            
    )
};

export default connect()(Login);
